"use strict";
/* eslint-disable no-await-in-loop,no-restricted-syntax */
// noinspection JSUnusedGlobalSymbols
Object.defineProperty(exports, "__esModule", { value: true });
exports.Person = exports.PersonAccountingSync = exports.OrganizationPersonStatus = void 0;
const firebase_1 = require("../../bindings/firebase");
const role_1 = require("../roles/role");
const room_1 = require("../rooms/room");
var OrganizationPersonStatus;
(function (OrganizationPersonStatus) {
    OrganizationPersonStatus[OrganizationPersonStatus["ACTIVE"] = 0] = "ACTIVE";
    OrganizationPersonStatus[OrganizationPersonStatus["LEAVE"] = 1] = "LEAVE";
    OrganizationPersonStatus[OrganizationPersonStatus["TEMPORARY"] = 2] = "TEMPORARY";
    OrganizationPersonStatus[OrganizationPersonStatus["TERMINATED"] = 3] = "TERMINATED";
    OrganizationPersonStatus[OrganizationPersonStatus["PARENT_OF_ACTIVEMEMBER"] = 4] = "PARENT_OF_ACTIVEMEMBER";
    OrganizationPersonStatus[OrganizationPersonStatus["UNKNOWN"] = 5] = "UNKNOWN";
})(OrganizationPersonStatus = exports.OrganizationPersonStatus || (exports.OrganizationPersonStatus = {}));
var PersonAccountingSync;
(function (PersonAccountingSync) {
    PersonAccountingSync[PersonAccountingSync["NONE"] = 0] = "NONE";
    PersonAccountingSync[PersonAccountingSync["FIKEN"] = 1] = "FIKEN";
    PersonAccountingSync[PersonAccountingSync["VISMA"] = 2] = "VISMA";
})(PersonAccountingSync = exports.PersonAccountingSync || (exports.PersonAccountingSync = {}));
class Person {
    constructor(person) {
        this.accounting_sync = PersonAccountingSync.NONE;
        // private _membershipData?: Membership;
        // private _loadedVersion?: 1 | 2 = 2;
        this.changes = {};
        this._metadata = {};
        if ('accounting_sync' in person) {
            this.accounting_sync = person.accounting_sync;
        }
        if ('accounting_data' in person) {
            this.accounting_data = person.accounting_data;
        }
        this.accounting_remote_id = person.accounting_remote_id;
        this.active = person.active;
        this.update_process = person.update_process;
        this.created = person.created;
        this.altered = person.altered;
        this.altered_by = person.altered_by;
        this.altered_by_reference = person.altered_by_reference;
        this.contact = person.contact;
        this.force_resync = person.force_resync;
        if (person.person_id) {
            this.person_id = person.person_id;
        }
        this.member_category = person.member_category;
        this.address = person.address;
        this.is_member = person.is_member;
        this.is_parent = person.is_parent;
        this.name = person.name;
        this.person_status = person.person_status;
        this.group = person.group;
        this.contingent = person.contingent;
        this.department = person.department;
        this.secondary_group = person.secondary_group;
        this.accounting_home_parent = person.accounting_home_parent;
        this.instrument_group = person.instrument_group;
        this.secondary_instrument_group = person.secondary_instrument_group;
        this.birthday = person.birthday;
        this.accounting_new = person.accounting_new;
        this.gender = person.gender;
        this.comment = person.comment;
        this.families = person.families;
        this.non_standard_postcode = person.non_standard_postcode;
        this.tags = [];
        this.external_tags = [];
        this.shard_refs = person.shard_refs;
        this.is_instructor = person.is_instructor;
        this.instructors = person.instructors;
        this.verification_date = person.verification_date;
        this.privacy_settings = person.privacy_settings;
        if (person.tags) {
            this.tags = person.tags;
        }
        if (person.external_tags) {
            this.external_tags = person.external_tags;
        }
        if (person.pictures) {
            this.pictures = person.pictures;
        }
        if (person.person_portal) {
            this.person_portal = person.person_portal;
        }
        if (person.person_sentral) {
            this.person_sentral = person.person_sentral;
        }
        this.version = person.version;
        this.birthday = person.birthday;
        this.accounting_sync_error = person.accounting_sync_error;
        this.active_membership = person.active_membership;
        if (person.custom_fields) {
            this.custom_fields = person.custom_fields;
        }
        if (person.custom_tags) {
            this.custom_tags = person.custom_tags;
        }
        if (person.subscriptions) {
            this.subscriptions = person.subscriptions;
        }
        if (person.rooms) {
            this.rooms = person.rooms;
        }
        if (person.roles) {
            this.roles = person.roles;
        }
        if (person.membership_type) {
            this.membership_type = person.membership_type;
        }
        if (person.children) {
            this._childrenRefs = person.children;
        }
        if (person.parents) {
            this._parentsRefs = person.parents;
        }
    }
    static new(data) {
        const personData = {
            altered: firebase_1.firebase.firestore.Timestamp.now(),
            contact: {},
            address: {},
            created: firebase_1.firebase.firestore.Timestamp.now(),
            custom_fields: {},
            gender: 'I',
            name: {
                first_name: '',
                last_name: '',
            },
            person_status: OrganizationPersonStatus.UNKNOWN,
            version: 2,
        };
        if (data) {
            Object.keys(data).forEach((key) => {
                // already have checks that key is in both
                personData[key] = data[key];
            });
        }
        return new this(personData);
    }
    update(data) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key of Object.keys(data)) {
            if (data[key] instanceof firebase_1.firebase.firestore.FieldValue) {
                this[key] = undefined;
            }
            else {
                this[key] = data[key];
            }
            this.changes = { ...this.changes, ...data };
        }
    }
    async submitUpdate() {
        if (Object.keys(this.changes).length === 0) {
            return null;
        }
        return this.ref().update(this.changes);
    }
    static fromQueryDocumentSnapshot(snapshot) {
        if (!snapshot.exists) {
            throw new Error('Person snapshot does not exist.');
        }
        const person = this.new(snapshot.data());
        person._querySnap = snapshot;
        person._ref = snapshot.ref;
        person._parentId = snapshot.ref.parent.parent.id;
        // person.setupMembership()
        return person;
    }
    static fromQuerySnapshot(snapshot) {
        const persons = [];
        if (snapshot.empty) {
            return persons;
        }
        for (const d of snapshot.docs) {
            const person = this.fromQueryDocumentSnapshot(d);
            if (person) {
                persons.push(person);
            }
        }
        return persons;
    }
    static async fromFirebase(orgid, personid) {
        const snapshot = await (0, firebase_1.fs)()
            .collection('organizations')
            .doc(orgid)
            .collection('persons')
            .doc(personid)
            .get();
        return this.fromQueryDocumentSnapshot(snapshot);
    }
    static async fromReference(reference) {
        const snapshot = await (0, firebase_1.fs)().doc(reference.path).get();
        return this.fromQueryDocumentSnapshot(snapshot);
    }
    getRaw() {
        // @ts-ignore
        const rawData = { ...this };
        Object.keys(rawData).forEach((key) => {
            if (key.startsWith('_')) {
                delete rawData[key];
            }
        });
        return rawData;
    }
    async set_accounting_data(data, sync, remote_id, parent, batch) {
        if (this.accounting_sync_error) {
            this.accounting_sync_error = undefined;
        }
        this.accounting_data = data;
        if (remote_id) {
            this.accounting_remote_id = remote_id;
        }
        this.accounting_sync = sync || PersonAccountingSync.NONE;
        if (parent) {
            this.accounting_home_parent = parent;
        }
        if (this.ref()) {
            if (batch) {
                batch.update(this.ref(), {
                    accounting_sync_error: firebase_1.firebase.firestore.FieldValue.delete(),
                    accounting_data: data || {},
                    accounting_remote_id: remote_id || this.accounting_remote_id,
                    accounting_sync: sync || PersonAccountingSync.NONE,
                    accounting_home_parent: parent || firebase_1.firebase.firestore.FieldValue.delete(),
                });
            }
            else {
                await this.querySnap().ref.update({
                    accounting_sync_error: firebase_1.firebase.firestore.FieldValue.delete(),
                    accounting_data: data || {},
                    accounting_remote_id: remote_id || this.accounting_remote_id,
                    accounting_sync: sync || PersonAccountingSync.NONE,
                    accounting_home_parent: parent || firebase_1.firebase.firestore.FieldValue.delete(),
                });
            }
        }
    }
    get metadata() {
        return this._metadata;
    }
    set metadata(value) {
        this._metadata = value;
    }
    parentID() {
        var _a;
        if (!this._parentId) {
            throw new Error(`Somehow parentid does not exist! ${(_a = this.contact) === null || _a === void 0 ? void 0 : _a.email_1}`);
        }
        return this._parentId;
    }
    querySnap() {
        var _a;
        if (!this._querySnap) {
            throw new Error(`Somehow querysnap does not exist! ${(_a = this.contact) === null || _a === void 0 ? void 0 : _a.email_1}`);
        }
        return this._querySnap;
    }
    ref() {
        var _a;
        if (!this._ref) {
            throw new Error(`Somehow ref does not exist! ${(_a = this.contact) === null || _a === void 0 ? void 0 : _a.email_1}`);
        }
        return this._ref;
    }
    async getRoles() {
        if (this._roles) {
            return this._roles;
        }
        const qs = this.querySnap();
        if (!qs) {
            return [];
        }
        const rolesSnap = await qs.ref.parent
            .parent.collection('roles')
            .where('members', 'array-contains', qs.ref)
            .get();
        this._roles = role_1.OrganizationRole.fromQuerySnapshot(rolesSnap);
        return this._roles;
    }
    async getRooms() {
        if (this._rooms) {
            return this._rooms;
        }
        const rooms = new Map();
        const roles = await this.getRoles();
        for (const role of roles) {
            if (role.room && !rooms.has(role.room)) {
                const room = room_1.Room.fromQueryDocumentSnapshot((await role.room.get()));
                if (room) {
                    rooms.set(role.room, room);
                }
            }
        }
        this._rooms = rooms;
        return this._rooms;
    }
    /**
     * Allows us to override contents of children field
     * @param children
     */
    setChildren(children) {
        this._children = children;
        this._childrenRefs = children.length ? children.map((child) => child.ref()) : undefined;
    }
    async getChildrenRefs() {
        var _a, _b;
        if (!this._childrenRefs) {
            const children = await this._children;
            if (!children) {
                const childrenFromCollection = (await ((_a = this.ref()) === null || _a === void 0 ? void 0 : _a.collection('children').get())).docs.map((d) => d.ref);
                this._childrenRefs = (childrenFromCollection === null || childrenFromCollection === void 0 ? void 0 : childrenFromCollection.length) ?
                    childrenFromCollection :
                    undefined;
            }
            else {
                this._childrenRefs = children.length ?
                    children.map((child) => child.ref()) :
                    undefined;
            }
        }
        return (_b = this._childrenRefs) !== null && _b !== void 0 ? _b : [];
    }
    async getChildren(force, useInternalRefs = false) {
        var _a;
        if (this._children && !force) {
            return this._children;
        }
        if (!this.querySnap()) {
            return [];
        }
        let childrenRefs;
        if (useInternalRefs) {
            childrenRefs = this._childrenRefs;
        }
        if (!childrenRefs || (force && useInternalRefs && !(childrenRefs === null || childrenRefs === void 0 ? void 0 : childrenRefs.length))) {
            childrenRefs = (_a = (await this.ref().collection('children').get()).docs) === null || _a === void 0 ? void 0 : _a.map((d) => d.ref);
        }
        const children = await (childrenRefs || []).reduce(async (output, { id }) => {
            const childSnap = await this.getOrgRef()
                .collection('persons')
                .doc(id)
                .get();
            if (!childSnap.exists) {
                return output;
            }
            const child = Person.fromQueryDocumentSnapshot(childSnap);
            const prev = await output;
            return prev.concat([child]);
        }, Promise.resolve([]));
        this._children = children;
        return children;
    }
    getChildrenSync() {
        if (Array.isArray(this._children)) {
            return this._children;
        }
        return [];
    }
    async getChildrenAsync(force) {
        if (this._children && !force) {
            return this._children;
        }
        const qs = this.querySnap();
        const children = [];
        if (!qs) {
            return children;
        }
        const childLinks = await qs.ref.collection('children').get();
        const promises = [];
        for (const ff of childLinks.docs) {
            promises.push(ff.data().ref.get());
        }
        const childDocumentSnapshots = await Promise.all(promises);
        for (const child of childDocumentSnapshots) {
            const p = await Person.fromQueryDocumentSnapshot(child);
            if (p) {
                p.setupSub();
                children.push(p);
            }
        }
        this._children = children;
        return children;
    }
    /**
     * Allows us to override contents of parents field
     * @param parents
     */
    setParents(parents) {
        this._parents = parents;
        this._parentsRefs = parents.length ? parents.map((parent) => parent.ref()) : undefined;
    }
    async getParentsRefs() {
        var _a, _b;
        if (!this._parentsRefs) {
            const parents = await this._parents;
            if (!parents) {
                const parentsFromCollection = (await ((_a = this.ref()) === null || _a === void 0 ? void 0 : _a.collection('parents').get())).docs.map((p) => p.ref);
                this._parentsRefs = (parentsFromCollection === null || parentsFromCollection === void 0 ? void 0 : parentsFromCollection.length) ?
                    parentsFromCollection :
                    undefined;
            }
            else {
                this._parentsRefs = parents.length ?
                    parents.map((parent) => parent.ref()) :
                    undefined;
            }
        }
        return (_b = this._parentsRefs) !== null && _b !== void 0 ? _b : [];
    }
    async getParents(force, useInternalRefs = false) {
        var _a;
        if (this._parents && !force) {
            return this._parents;
        }
        if (!this.querySnap()) {
            return [];
        }
        let parentRefs;
        if (useInternalRefs) {
            parentRefs = this._parentsRefs;
        }
        if (!parentRefs || (force && useInternalRefs && !(parentRefs === null || parentRefs === void 0 ? void 0 : parentRefs.length))) {
            parentRefs = (_a = (await this.ref().collection('parents').get()).docs) === null || _a === void 0 ? void 0 : _a.map((d) => d.ref);
        }
        const parents = await (parentRefs || []).reduce(async (output, { id }) => {
            const parentSnapShot = await this.getOrgRef()
                .collection('persons')
                .doc(id)
                .get();
            if (!parentSnapShot.exists) {
                return output;
            }
            const parent = Person.fromQueryDocumentSnapshot(parentSnapShot);
            const prev = await output;
            return prev.concat([parent]);
        }, Promise.resolve([]));
        this._parents = parents;
        return parents;
    }
    getParentsSync() {
        if (Array.isArray(this._parents)) {
            return this._parents;
        }
        return [];
    }
    setupSub(callback) {
        if (this.ref()) {
            this._sub = (0, firebase_1.fs)()
                .doc(this.ref().path)
                .onSnapshot((snap) => {
                if (snap && snap.exists && snap.data()) {
                    const data = snap.data();
                    Object.keys(data).forEach((key) => {
                        // already have checks that key is in both
                        this[key] = data[key];
                    });
                    if (callback) {
                        callback();
                    }
                }
            });
        }
    }
    killSub() {
        if (this._sub) {
            this._sub();
        }
    }
    fullName() {
        if ((!this.name.first_name || this.name.first_name.length === 0) &&
            this.name.last_name) {
            return this.name.last_name;
        }
        if ((!this.name.last_name || this.name.last_name.length === 0) &&
            this.name.first_name) {
            return this.name.first_name;
        }
        return `${this.name.first_name} ${this.name.last_name}`;
    }
    initials() {
        if ((!this.name.first_name || this.name.first_name.length === 0) &&
            this.name.last_name) {
            return this.name.last_name[0];
        }
        if ((!this.name.last_name || this.name.last_name.length === 0) &&
            this.name.first_name) {
            return this.name.first_name[0];
        }
        return `${this.name.first_name[0]}${this.name.last_name[0]}`;
    }
    getOrgId() {
        var _a;
        const orgRef = this.querySnap().ref.parent.parent;
        if (!orgRef) {
            throw new Error(`Somehow organization does not exist! ${(_a = this.contact) === null || _a === void 0 ? void 0 : _a.email_1}`);
        }
        return orgRef.id;
    }
    getOrgRef() {
        var _a;
        const orgRef = this.querySnap().ref.parent.parent;
        if (!orgRef) {
            throw new Error(`Somehow organization does not exist! ${(_a = this.contact) === null || _a === void 0 ? void 0 : _a.email_1}`);
        }
        return orgRef;
    }
    getId() {
        var _a;
        const qs = this.querySnap();
        if (!qs) {
            throw new Error(`Somehow id does not exist! ${(_a = this.contact) === null || _a === void 0 ? void 0 : _a.email_1}`);
        }
        return qs.id;
    }
}
exports.Person = Person;
//# sourceMappingURL=organizationPerson.js.map